var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "beverage slide",
      class: { up: !_vm.beverage.show, detailed: _vm.detailed }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-10" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "headers" }, [
              _c(
                "div",
                {
                  staticClass: "bev-icon-container",
                  class: [
                    _vm.beverage.basis,
                    { packaged: _vm.beverage.packaged }
                  ]
                },
                [
                  _c("span", {
                    staticClass: "bev-icon",
                    class: [_vm.beverage.basis]
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.beverage.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brand" }, [
                _vm._v(_vm._s(_vm.beverage.brand))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "more" }, [
              _vm.beverage.note
                ? _c("span", { staticClass: "icon icon-note note-tip" })
                : _vm._e(),
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm._f("startWithCap")(
                      _vm._f("join")(_vm.beverage.benefits, ", ")
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "strength" },
              [
                _c("div", { staticClass: "time" }, [
                  _c(
                    "ul",
                    [
                      _c("time-icon", {
                        attrs: { times: _vm.beverage.times, time: "morning" }
                      }),
                      _vm._v(" "),
                      _c("time-icon", {
                        attrs: { times: _vm.beverage.times, time: "daytime" }
                      }),
                      _vm._v(" "),
                      _c("time-icon", {
                        attrs: { times: _vm.beverage.times, time: "evening" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("theine-level", { attrs: { theine: _vm.beverage.theine } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "preparation" },
              [
                _c("min-max", {
                  attrs: {
                    display: _vm.beverage.preparation.temp,
                    icon: "icon-temp",
                    unit: _vm._f("map")(_vm.temperatureUnit, _vm.i18n.units)
                  }
                }),
                _vm._v(" "),
                _c("min-max", {
                  attrs: {
                    display: _vm.beverage.preparation.time,
                    icon: "icon-time",
                    unit: _vm.i18n.units.minutes
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("p", { staticClass: "ingredients" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("startWithCap")(
                      _vm._f("join")(_vm.beverage.ingredients, ", ")
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _vm.beverage.note
                ? _c("p", { staticClass: "note" }, [
                    _c("span", { staticClass: "icon icon-note" }),
                    _vm._v(" " + _vm._s(_vm.beverage.note) + "\n          ")
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-2 actions" }, [
          _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
            _c(
              "button",
              {
                staticClass: "clickable",
                attrs: { "data-tooltip": _vm.i18n.beverage.expand },
                on: { click: _vm.toggleDetails }
              },
              [_c("span", { staticClass: "icon icon-detail" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "clickable",
                attrs: { "data-tooltip": _vm.i18n.beverage.order },
                on: {
                  click: function($event) {
                    _vm.orderBeverage({ beverage: _vm.beverage })
                  }
                }
              },
              [_c("span", { staticClass: "icon icon-pick" })]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27dd4a98", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27dd4a98","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/beverages/beverage/beverage.html
// module id = 162
// module chunks = 0